const currentMonth = () => {
    let month = new Date().getMonth() + 1;

    switch (month) {
        case 1:
            return 'jan';
            break;
        case 2:
            return 'feb';
            break;
        case 3:
            return 'mar';
            break;
        case 4:
            return 'apr';
            break;
        case 5:
            return 'may';
            break;
        case 6:
            return 'jun';
            break;
        case 7:
            return 'jul';
            break;
        case 8:
            return 'aug';
            break;
        case 9:
            return 'sep';
            break;
        case 10:
            return 'oct';
            break;
        case 11:
            return 'nov';
            break;
        case 12:
            return 'dec';
            break;
        default:
            console.log(`Couldn't figure out the month.`);
    }
};

export default currentMonth;